import PolicyService from "modules/policies/services/policy.service";
import SalesPortfolioService from "modules/sales-policies/services/sales-portfolio.service";
import { NextRouter } from "next/router";
import { DEFAULT_PAGE_NUMBER, PAGE_SIZE } from "../constants/page.constants";

interface RecentClaimStatus {
    recentCla?: string;
    errorMessage?: string;
}

export async function checkRecentClaims(router: NextRouter, policyNo: string, policyLineNo: string) {
    try {
        const claimStatusResponse: RecentClaimStatus = await SalesPortfolioService.getRecentClaimStatus(policyNo, policyLineNo);
        if (claimStatusResponse?.recentCla === "Y") {
            // Navigate to be-informed page
            router.push({ 
                pathname: `/policies/${policyNo}/error`, 
                query: { page: "claims", category: "fileClaimError", message: "recentClaimRegistered" }
            });
            return true;
        }
        else if (claimStatusResponse?.errorMessage) {
            // Navigate to error page
            router.push({ 
                pathname: `/policies/${policyNo}/error`, 
                query: { category: "errors", message: "invalidPolicyNo" }
            });
            return true;
        }
    } catch (error) {
        console.log("Claim status fetch failed: ", error);
        router.push({ 
            pathname: `/policies/${policyNo}/error`,
            query: { category: "errors", message: "sorrySomethingWentWrong" } 
        });
        return true;
    }
    return false;
}

export function checkPoliciesStatus(setOnBoardedUser: (value: React.SetStateAction<boolean>) => void) {
    PolicyService.getPoliciesStatus(DEFAULT_PAGE_NUMBER, PAGE_SIZE).then((policiesStatus) => {
        if (policiesStatus?.active > 0 || policiesStatus?.cancelled > 0) {
            setOnBoardedUser(false);
        }
    });
}